/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { cssParser } from '../utils/parser';

const isLevelComplete = () => {
    return document.getElementById("garden")?.style.backgroundColor === "brown";
};

const Garden = ({ css, onComplete }) => {

    useEffect(() => {
        if (isLevelComplete()) {
            onComplete();
        };
    }, [css])

    return (
        <div id="garden" style={cssParser(css, { mandatoryStyles: { display: "flex", "justifyContent": "center", "alignItems": "center" } })}>
            <p style={{
                "position": "absolute",
                "top": "40px",
                "left": "45px",
                "color": "black"
            }}>#sand</p>
            <div id="plant">
                {
                    isLevelComplete() ?
                        <img src="/images/plant-large.png" alt="large-plant" />
                        :
                        <img src="/images/plant-small.png" alt="small-plant" />
                }
            </div>
        </div >
    )
}

export default Garden;